module.exports = __webpack_public_path__ + "media/images/area/feature/kanto/related/vi/3-7e0f40eedaa9cd38ffbfded5cf3c1ac6.jpg";